import { render, staticRenderFns } from "./MenuBanner.vue?vue&type=template&id=94a5dbe2"
import script from "./MenuBanner.vue?vue&type=script&lang=js"
export * from "./MenuBanner.vue?vue&type=script&lang=js"
import style0 from "./MenuBanner.vue?vue&type=style&index=0&id=94a5dbe2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports